import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetProductCatalogCollectionDisplayInfosByRefsQueryVariables = Types.Exact<{
  collectionsRefList: Array<Types.ProductCatalogDisplayInfoRef> | Types.ProductCatalogDisplayInfoRef;
}>;

export type GetProductCatalogCollectionDisplayInfosByRefsQuery = {
  __typename?: 'Query';
  productCatalogCollectionDisplayInfosByRefs: Array<{
    __typename?: 'ProductCatalogCollectionDisplayInfo';
    id: string;
    displayInfoId: string;
    pdpSectionType?: Types.PDPSectionType | null;
    title: string;
    collection: {
      __typename?: 'ProductCatalogCollection';
      id: string;
      collectionType: Types.ProductCatalogCollectionType;
      members: Array<
        | { __typename?: 'ProductCatalogEntityBrand' }
        | { __typename?: 'ProductCatalogEntityCategory' }
        | { __typename?: 'ProductCatalogEntityCuration' }
        | {
            __typename?: 'ProductCatalogEntityItem';
            id: string;
            catalogItemData?: {
              __typename?: 'ProductCatalogItem';
              whyWeLoveIt?: string | null;
              shortDescription?: string | null;
              longDescription?: string | null;
              id: string;
              title: string;
              itemType: string;
              productUrl?: string | null;
              isFullPrice: boolean;
              tags: Array<string>;
              group?: {
                __typename?: 'ProductCatalogItemGroup';
                id: string;
                groupDimensions: Array<{ __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string }>;
              } | null;
              retailer?: { __typename?: 'ProductCatalogRetailer'; name: string } | null;
              subCategories: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string; title: string }>;
              brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
              price?: {
                __typename?: 'MonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'Currency'; code: string; places: number } | null;
              } | null;
              fullPrice?: {
                __typename?: 'MonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'Currency'; code: string; places: number } | null;
              } | null;
              storefrontInfo: {
                __typename?: 'ProductCatalogStorefrontInfo';
                storefrontStatus: Types.ProductCatalogStorefrontStatus;
                canAddToCart: boolean;
                canAddToRegistry: boolean;
              };
              rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
            } | null;
          }
        | { __typename?: 'ProductCatalogEntityItemGroup' }
      >;
    };
  } | null>;
};

export const GetProductCatalogCollectionDisplayInfosByRefsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductCatalogCollectionDisplayInfosByRefs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionsRefList' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogDisplayInfoRef' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCollectionDisplayInfosByRefs' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'refs' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionsRefList' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayInfoId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpSectionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogEntityItem' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'catalogItemData' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpDisplayFields' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'group' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'groupDimensions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retailer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyWeLoveIt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetProductCatalogCollectionDisplayInfosByRefsQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogCollectionDisplayInfosByRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogCollectionDisplayInfosByRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogCollectionDisplayInfosByRefsQuery({
 *   variables: {
 *      collectionsRefList: // value for 'collectionsRefList'
 *   },
 * });
 */
export function useGetProductCatalogCollectionDisplayInfosByRefsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>(
    GetProductCatalogCollectionDisplayInfosByRefsDocument,
    baseOptions,
  );
}
export function useGetProductCatalogCollectionDisplayInfosByRefsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>(
    GetProductCatalogCollectionDisplayInfosByRefsDocument,
    baseOptions,
  );
}
export type GetProductCatalogCollectionDisplayInfosByRefsQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionDisplayInfosByRefsQuery>;
export type GetProductCatalogCollectionDisplayInfosByRefsLazyQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionDisplayInfosByRefsLazyQuery>;
export type GetProductCatalogCollectionDisplayInfosByRefsQueryResult = Apollo.QueryResult<
  GetProductCatalogCollectionDisplayInfosByRefsQuery,
  GetProductCatalogCollectionDisplayInfosByRefsQueryVariables
>;
